"use client"
import { parseAsStringLiteral, useQueryState } from "nuqs"
import { useCallback } from "react"

export const WATCHLIST_KIND_OPTIONS = ["nfts", "tokens"] as const

type Kind = "nfts" | "tokens"

const parser = parseAsStringLiteral<Kind>(WATCHLIST_KIND_OPTIONS)

export function useWatchlistKindQueryParam() {
  const [kind, setKindState] = useQueryState("kind", parser.withDefault("nfts"))

  const setKind = useCallback(
    async (next: Kind) => {
      await setKindState(next === "nfts" ? null : next)
    },
    [setKindState],
  )

  return { kind, setKind }
}
